import { apiRequest } from "@/common/api/ApiRequest.ts";
import type {
  CmmnCodeOptionType,
  CmmnCodeType,
  DeptType,
  StaffType,
  StudentType,
  CudResultType,
  VDeptType,
} from "@/common/types/cmmn/CmmnTypes";
import { ApiMethod } from "@/common/types/Enums";
import type { ExcelHeader } from "@/common/types/ExcelTypes";

const _url = "/api/v1/cmmn";
const VITE_APP_TYPE = import.meta.env.VITE_APP_TYPE as string;

/**
 * summary: Get Code List
 * #GET./api/v1/cmmn/code
 */
export const getCmmnList = async (params: ParamsType): Promise<CmmnCodeType[]> => {
  if (!params.upCd) {
    console.warn("upCd is null");
    throw new Error("upCd is required");
  }
  return await apiRequest<CmmnCodeType[]>({
    url: _url + "/code",
    params: params,
  });
};

/**
 * summary: Get Cmmn Code Option
 * #GET./api/v1/cmmn/code-option
 */
export const getCmmnCdOption = async (
  params: ParamsType
): Promise<Record<string, CmmnCodeOptionType[]>> => {
  if (!params.upCdArr) {
    console.warn("upCdArr is null");
    throw new Error("upCdArr is required");
  }

  const upCds = params.upCdArr as string[];
  if (upCds.length === 0) {
    console.warn("upCdArr length is 0");
    throw new Error("upCdArr length is 0");
  }
  return await apiRequest<Record<string, CmmnCodeOptionType[]>>({
    url: _url + "/code-option",
    params: params,
  });
};

/**
 * summary: Check Duplicate Value
 * #GET.guide/chkDupValue
 */
export const chkDupValue = async (params: ParamsType): Promise<string[]> => {
  return await apiRequest<string[]>({
    method: ApiMethod.GET,
    url: _url + "/chkDupValue",
    params: params,
  });
};

export const uploadExcel = async (
  tableName: string,
  data: { headers: ExcelHeader[]; data: ParamsType[] }
): Promise<CudResultType> => {
  if (!tableName) {
    console.warn("tableName is null");
    throw new Error("tableName is required");
  }
  if (data.data.length === 0) {
    console.warn("data is empty");
    throw new Error("data is required");
  }
  if (data.headers.length === 0) {
    console.warn("headers is empty");
    throw new Error("headers is required");
  }
  return await apiRequest<CudResultType>({
    method: ApiMethod.POST,
    url: "/api/v1/cmmn/excel-upload",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      data: data.data,
      headers: data.headers,
      tableName: tableName,
    },
    useLoading: false,
  });
};

/**
 * summary: Get Student List
 * #GET./api/v1/${VITE_APP_TYPE}/students
 */
export const getStudentList = async (params: ParamsType): Promise<StudentType[]> => {
  return await apiRequest<StudentType[]>({
    url: `/api/v1/${VITE_APP_TYPE}/students`,
    params: params,
  });
};

/**
 * summary: Get Staff List
 * #GET./api/v1/${VITE_APP_TYPE}/staffs
 */
export const getStaffList = async (params: ParamsType): Promise<StaffType[]> => {
  return await apiRequest<StaffType[]>({
    url: `/api/v1/${VITE_APP_TYPE}/staffs`,
    params: params,
  });
};

/**
 * summary: Get Dept List
 * #GET./api/v1/cmmn/depts
 */
export const getDeptList = async (params: ParamsType): Promise<DeptType[]> => {
  return await apiRequest<DeptType[]>({
    url: `/api/v1/cmmn/depts`,
    params: params,
  });
};

/************************* 부서 조회(동양대 교육설계지원 사이트) **************************/
/**
 * summary: Get VDept List
 * #GET./api/v1/cmmn/vdepts
 */
export const getVDeptList = async (params: ParamsType): Promise<VDeptType[]> => {
  return await apiRequest<VDeptType[]>({
    url: "/api/v1/cmmn/vdepts",
    params: params,
  });
};
/************************* 부서 조회(동양대 교육설계지원 사이트) **************************/

export default {
  getCmmnList,
  getCmmnCdOption,
  getStudentList,
  getStaffList,
};
